export const width = 900;
export const height = 300;

export const margin = {
  top: 50,
  right: 50,
  bottom: 50,
  left: 50,
}

export const seriesSize = 12;

export default {
  width,
  height,
  margin,
  seriesSize
}



// WEBPACK FOOTER //
// ./src/components/WordTimeline/Visualization/constants.js